<template>
  <Modal class="long-modal top-modal"  width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">
      查看续约意向
    </div>
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="loading"></table-list>
    </div>
    <div slot="footer">
      <div>  
        <Button  type="primary" size="large" @click="close">确定</Button>
      </div>
    </div>
  </Modal>
</template>
 
<script type="text/ecmascript-6">
 import {formatDateTime} from "@/utils/format.js"
 import TableList from "components/TableList/index";
 import { readRenewIntention } from 'api/renewalIntention'
 
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    contractId:{
      type:String,
      default:''
    }
  },
  watch:{
    n() { 
      this.show = true
      this.loading = true
      readRenewIntention(this.contractId).then( res => {
        this.tableData = res.data
      }).finally( () => {
        this.loading = false
      })
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    loading:false,
    columns:[
      {
      title: "续约意向",
      key: "stateName",
      align: "center"
     
      },
      {
        title: "操作人",
        key: "operatorName",
        align: "center"
      
      },
      {
        title: "操作时间",
        key: "operationTime",
        align: "center",
        render: (h,params) => {
          return h('div',formatDateTime(params.row.operationTime))
        }
      },
      {
        title: "备注",
        key: "remark",
        align: "center"
      }
    ],
    tableData:[]
 };
 },
 methods:{
   close() {
     this.show = false
   }
 }
}
</script>




